module.exports = __webpack_public_path__ + "img/nc.d4438b49.svg";